export const REQUEST = 'Admin/Surveys/REQUEST';
export const SUCCESS = 'Admin/Surveys/SUCCESS';
export const ERROR = 'Admin/Surveys/ERROR';

export const SET = 'Admin/Surveys/SET';